export const CStaticResourceType = {
    IMAGES: 'IMAGES',
    JSON: 'JSON',
    FONTS: 'FONTS'
} as const;

export const staticLocalServerUrl = 'http://localhost:4300'